// extracted by mini-css-extract-plugin
export var backgroundImage = "_p-1";
export var container = "_p-0";
export var title = "_p-2";